import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SCREEN_ID_ADMIN_GOING_TO_MARKET } from 'client/constants/screenIds';

import { DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS } from 'common/dataTableConstants';

import {
  LISTING_SERVICE_TYPE_FULL_SERVICE,
  LISTING_SERVICE_TYPE_SUNRISE,
} from 'common/listingConstants';

import { MARKETING_PARTNER_LISTING_CATEGORY_PRE_LEASE } from 'common/marketingPartnerListingConstants';

import { actionDataTableLoadItems } from 'client/helpers/dataTables';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';

import AccountManagerActions from 'client/actions/AccountManager';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrPage from 'client/components/SrPage';
import SrDataTableMarketingPartnerListings from 'client/components/SrDataTableMarketingPartnerListings';
import SrFlex from 'client/components/SrFlex';

const SERVICE_TYPES = [
  {
    label: 'Full-Service',
    value: LISTING_SERVICE_TYPE_FULL_SERVICE,
  },
  {
    label: 'SunSetup',
    value: LISTING_SERVICE_TYPE_SUNRISE,
  },
  {
    label: 'Pre-Lease',
    value: MARKETING_PARTNER_LISTING_CATEGORY_PRE_LEASE,
  },
];

export const SETUP_HEALTH_FILTER_LOW_HEALTH = 'SETUP_HEALTH_FILTER_LOW_HEALTH';

const SETUP_HEALTH_OPTIONS = [
  {
    label: 'Low Health',
    value: SETUP_HEALTH_FILTER_LOW_HEALTH,
  },
];

@withTransitionHook
@withScreenId(SCREEN_ID_ADMIN_GOING_TO_MARKET)
@withScrollToTop
@branch()
@branch(() => ({
  accountManagers: ['accountManagers', 'listWithPartners'],
  appUrl: ['env', 'APP_URL'],
}))
class AdminGoingToMarketPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Going To Market',
    section: 'Admin',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    appUrl: PropTypes.string.isRequired,
    accountManagers: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      accountManagerId: null,
      serviceType: null,
      setupHealthFilter: null,
    };
  }

  static fetchData(match, inject) {
    return Promise.all([AccountManagerActions.getListWithPartners(inject)]);
  }

  _onReloadDataTableMarketingPartnerListing = (marketingPartnerListing) => {
    const { dispatch } = this.props;

    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
      viewId: `by-marketing-partner-listing-id-${marketingPartnerListing.id}`,
      filter: {
        'marketingPartnerListings.id': marketingPartnerListing.id,
      },
      count: 1,
    });
  };

  _handleServiceTypeUpdate = (e) => {
    const newServiceType = e.target.value;
    if (newServiceType !== LISTING_SERVICE_TYPE_FULL_SERVICE) {
      return this.setState({
        serviceType: e.target.value,
        setupHealthFilter: null,
      });
    }
    return this.setState({
      serviceType: e.target.value,
    });
  };

  _handleSetupHealthUpdate = (e) => {
    this.setState({
      serviceType: LISTING_SERVICE_TYPE_FULL_SERVICE,
      setupHealthFilter: e.target.value,
    });
  };

  render() {
    const { appUrl, accountManagers } = this.props;

    const { accountManagerId, serviceType, setupHealthFilter } = this.state;

    return (
      <SrPage navbarProps={{ redirectLogoTo: '/admin' }}>
        <SrBox margin="50px 90px -32px 665px" zIndex="5">
          <SrFlex direction="row">
            {accountManagers && accountManagers.length && (
              <SrBox>
                <SrText size="large" weight="medium" color="blueGreycliff" font="greycliff">
                  Account Manager:&nbsp;
                </SrText>
                <select onChange={(e) => this.setState({ accountManagerId: e.target.value })}>
                  <option value="">All</option>
                  {accountManagers.map((accountManager) => (
                    <option
                      key={accountManager.id}
                      selected={accountManagerId === accountManager.id}
                      value={accountManager.id}
                    >
                      {accountManager.name}
                    </option>
                  ))}
                </select>
              </SrBox>
            )}
            <SrBox marginLeft="20px">
              <SrText size="large" weight="medium" color="blueGreycliff" font="greycliff">
                Listing Type: &nbsp;
              </SrText>
              <select onChange={(e) => this._handleServiceTypeUpdate(e)}>
                <option value="">All</option>
                {SERVICE_TYPES.map((service) => (
                  <option
                    key={service.value}
                    selected={serviceType === service.value}
                    value={service.value}
                  >
                    {service.label}
                  </option>
                ))}
              </select>
            </SrBox>
            <SrBox marginLeft="20px">
              <SrText size="large" weight="medium" color="blueGreycliff" font="greycliff">
                Setup Health: &nbsp;
              </SrText>
              <select onChange={(e) => this._handleSetupHealthUpdate(e)}>
                <option value="">All</option>
                {SETUP_HEALTH_OPTIONS.map((option) => (
                  <option
                    key={option.value}
                    selected={setupHealthFilter === option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
            </SrBox>
          </SrFlex>
        </SrBox>

        <SrBox className="width-90" marginTop="-75px">
          <SrDataTableMarketingPartnerListings
            reloadDataTableMarketingPartnerListing={this._onReloadDataTableMarketingPartnerListing}
            appUrl={appUrl}
            displayReferralProperties
            accountManagerId={accountManagerId}
            serviceType={serviceType}
            setupHealthFilter={setupHealthFilter}
          />
        </SrBox>
      </SrPage>
    );
  }
}

AdminGoingToMarketPage.displayName = 'AdminGoingToMarketPage';

export default AdminGoingToMarketPage;
